module.exports = __webpack_public_path__ + "img/submit-order-btn.80495713.png";